import { IReference } from '../../../../expressions/references/IReference';
import { WidgetType } from '../../../Widget';
import { IInputWidget } from '../../inputs/IInputWidget';

export interface IRepeatControllerWidget extends IInputWidget {
  type: WidgetType.RepeatController;
  kind: RepeatControllerComponentType;
  listReference: IReference;
  confirmReduce: boolean;
}

/**
 * Indica se il widget è un input (campo modificabile da utente)
 * oppure calcolato (il valore dipende da una formula)
 */
export enum RepeatControllerComponentType {
  Input = 'input',
}
